import { fetch } from './api.js';

export async function getMyCart() {
  return await fetch('/parse/classes/Cart/mine');
}

export async function addToCart(productId, title, price, image, slug, type, downloadUrl, quantity = 1, renewal = false, variationLabel = '') {
  return await fetch('/parse/classes/Cart/mine/items', {
    method: 'POST',
    body: JSON.stringify({ productId, title, price, image, slug, type, quantity, downloadUrl, renewal, variationLabel }),
  });
}

export async function updateCartItemQuantity(productId, quantity, variationLabel = '') {
  return await fetch(`/parse/classes/Cart/mine/items/${productId}`, {
    method: 'PUT',
    body: JSON.stringify({ quantity, variationLabel }),
  });
}

export async function removeCartItem(productId) {
  return await fetch(`/parse/classes/Cart/mine/items/${productId}`, {
    method: 'DELETE',
  });
}

export async function clearCart() {
  return await fetch('/parse/classes/Cart/mine', {
    method: 'DELETE',
  });
}
